exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".newTaskCircle{width:26px;height:26px;border-radius:17px;font-size:21px;text-align:center;line-height:1.23;margin:auto;background-color:#bbb;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/utility/icons/new_task_circle.scss
// module id = 1478
// module chunks = 0